(function(root){
'use strict';
const normalize=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
const code=s=>normalize(s).replace(/ /g,'');
function near(a,b){
 if(a===b)return true;if(Math.abs(a.length-b.length)>1)return false;
 let i=0;while(i<Math.min(a.length,b.length)&&a[i]===b[i])i++;
 if(a.length===b.length)return a.slice(i+1)===b.slice(i+1)||(a[i]===b[i+1]&&a[i+1]===b[i]&&a.slice(i+2)===b.slice(i+2));
 return a.length>b.length?a.slice(i+1)===b.slice(i):a.slice(i)===b.slice(i+1);
}
function create(rows){
 const entries=rows.map(row=>({row,sku:code(row[1]),names:[normalize(row[2]),normalize(row[3])],words:[...new Set(normalize(row[2]+' '+row[3]).split(' '))]}));
 const vocab=new Map();for(const e of entries)for(const w of e.words)if(/^[a-z]{5,}$/.test(w))vocab.set(w,(vocab.get(w)||0)+1);
 function correct(query){
  const q=normalize(query);if(!q||/\d/.test(q)||q.length>100)return null;
  const words=q.split(' ');let changed=false;const out=[];
  for(const w of words){
   if(w.length<5||vocab.has(w)){out.push(w);continue;}
   const candidates=[...vocab.keys()].filter(x=>near(w,x)).sort((a,b)=>vocab.get(b)-vocab.get(a));
   if(!candidates.length||candidates.length>1&&vocab.get(candidates[0])<vocab.get(candidates[1])*3)return null;
   out.push(candidates[0]);changed=true;
  }
  return changed?out.join(' '):null;
 }
 function find(query,limit=6){
  const q=normalize(query);if(q.length<2||q.length>150)return [];
  const compact=code(query),terms=q.split(' '),isCode=/\d/.test(q)&&!q.includes(' ');
  const ranked=[];
  for(const e of entries){
   let score=e.sku===compact?10000:0;
   if(!score&&compact.length>=4&&/\d/.test(compact)&&e.sku.startsWith(compact))score=700;
   if(!score&&!isCode){
    const all=terms.every(t=>e.words.some(w=>w.startsWith(t)));
    if(all){score=100+terms.filter(t=>e.words.includes(t)).length*10;if(e.names.some(n=>n.startsWith(q)))score+=100;else if(e.names.some(n=>n.includes(q)))score+=50;}
   }
   if(score)ranked.push({row:e.row,score});
  }
  ranked.sort((a,b)=>b.score-a.score||a.row[2].localeCompare(b.row[2]));
  const seen=new Set();return ranked.filter(x=>!seen.has(x.row[0])&&seen.add(x.row[0])).slice(0,limit);
 }
 return {find,correct,normalize,code};
}
root.GastroSearchMatch={create,normalize,code,near};
if(typeof module!=='undefined')module.exports=root.GastroSearchMatch;
})(typeof window!=='undefined'?window:globalThis);
